import Toast from './Toast.container';

export default Toast;